export const formatOperatingStatementLabel = ({
    year,
    month,
}: {
    year: number;
    month: number;
}): string => {
    const validMonth = Math.max(1, Math.min(12, month));
    const formattedMonth = validMonth.toString().padStart(2, "0");
    const formattedYear = (year % 100).toString().padStart(2, "0");

    return `${formattedMonth}/${formattedYear}`;
};

// Companion boolean key marking a field as manually edited; row objects can't
// hold an array (their index signature is scalar-only).
export const EDITED_FIELD_SUFFIX = "__edited";
export const editedFieldKey = (field: string): string =>
    `${field}${EDITED_FIELD_SUFFIX}`;

// Companion key holding an edited cell's originally extracted value (hundredths),
// so the UI can show original vs current.
export const ORIGINAL_FIELD_SUFFIX = "__original";
export const originalFieldKey = (field: string): string =>
    `${field}${ORIGINAL_FIELD_SUFFIX}`;

export const generateFieldId = (
    columnType: string | null | undefined,
    columnIndex: number | undefined,
): string => {
    if (columnType === "total") {
        return "operating-statement-total-column";
    }
    if (columnType === "period_to_date") {
        return `operating-statement-period-to-date-column-${columnIndex}`;
    }
    if (columnType === "year_to_date") {
        return `operating-statement-year-to-date-column-${columnIndex}`;
    }
    if (columnType === "unknown") {
        return `operating-statement-unknown-column-id-${columnIndex}`;
    }
    return `operating-statement-month-id-${columnIndex}`;
};
